import { Configuration, VehiclesApi } from '@control-center/control-center-client-public-vehicles-ts';
import { fetchAuthSession } from 'aws-amplify/auth';

const REQUEST_TIMEOUT_MS = 30_000;

export class RestError extends Error {
    readonly status: number;
    readonly body: unknown;

    constructor(message: string, status: number, body?: unknown) {
        super(message);
        this.name = 'RestError';
        this.status = status;
        this.body = body;
    }
}

export const getVehicleServiceAccessToken = async (): Promise<string> => {
    const token = (await fetchAuthSession()).tokens?.accessToken?.toString();
    if (!token) {
        throw new RestError('No Cognito access token available', 401);
    }
    return token;
};

const configuration = new Configuration({
    basePath: import.meta.env.VITE_VEHICLE_SERVICE_ENDPOINT?.replace(/\/+$/, ''),
    accessToken: getVehicleServiceAccessToken,
    baseOptions: {
        timeout: REQUEST_TIMEOUT_MS,
        headers: { accept: 'application/json' },
    },
});

export const vehiclesApi = new VehiclesApi(configuration);
